export interface AddressAddressee {
  id: string;
  addressId: string;
  addressee: string;
  addressSingleLine: string;
  obsolete: boolean;
}
